// extracted by mini-css-extract-plugin
module.exports = {"root":"CookieConsent_root__QV54C","message":"CookieConsent_message__3EuCx","cookieLink":"CookieConsent_cookieLink__1MxGV","continueBtn":"CookieConsent_continueBtn__1wgjz"};